
import { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../url';
import Dashboard from './Dashboard';
import Login from './Login';

interface UserSession {
    username: string;
    expiry: string;
}

interface AuthContextType {
    user: UserSession | null;
    login: (userData: UserSession) => void;
    logout: () => void;
}

const ProtectedRoute: React.FC<{ children: any }> = ({ children }) => {

    const navigate = useNavigate();

    useEffect(() => {
        const checkAuth = async () => {
            const token: any = JSON.parse(localStorage.getItem("token") || '{}');
            if (!token) {
                navigate("/login");
                return;
            }
            try {
                await fetch(`${window.location.protocol}//${BASE_URL}/dashboard/user`, {
                    headers: {
                        Authorization: `Bearer ${token.access_token}`
                    },
                }).then(
                    res => {
                        if (res.status == 200) {
                            return res.json()
                        }
                        localStorage.removeItem("token"); // Remove expired token
                        navigate("/login"); // Redirect to login
                    }
                ).catch(() => {
                    localStorage.removeItem("token"); // Remove expired token
                    navigate("/login"); // Redirect to login
                })
            } catch (error) {
                localStorage.removeItem("token"); // Remove expired token
                navigate("/login"); // Redirect to login
            }
        };
        checkAuth();
    }, [navigate]);

    return <>{children}</>;
};
  
const AppRoutes = () => {
    return <>
        <Routes>
            <Route path="/" element={<Navigate to={localStorage.getItem("userSession") ? "/dashboard" : "/login"} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={
                <ProtectedRoute>
                    <Dashboard />
                </ProtectedRoute>
            }/>
        </Routes>
    </>
}

export default AppRoutes;